<mat-toolbar class="header">
	<div class="logo-container">
		<img src="logo.png" alt="Matchie" class="logo" />
	</div>

	<span class="spacer"></span>

	<nav class="nav-items">
		<a
			mat-icon-button
			routerLink="/surveys"
			routerLinkActive="active"
			[routerLinkActiveOptions]="{ exact: false }"
			(click)="navigateTo('/surveys'); $event.preventDefault()"
			aria-label="Home"
		>
			<mat-icon fontSet="material-symbols-outlined">home</mat-icon>
		</a>
	</nav>

	<button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu">
		<div class="user-avatar">
			@if ((user$ | async)?.photo_url) {
				<img
					[src]="(user$ | async)?.photo_url"
					alt="Profile photo"
					(error)="onImageError($event)"
				/>
			}
			@if (!(user$ | async)?.photo_url) {
				<mat-icon>account_circle</mat-icon>
			}
		</div>
	</button>

	<mat-menu #userMenu="matMenu" class="user-menu-panel">
		@if (user$ | async; as user) {
			<div class="user-info">
				<p class="email">{{ user.email }}</p>
			</div>
		}
		<a
			mat-menu-item
			routerLink="/profile"
			(click)="navigateTo('/profile'); $event.preventDefault()"
		>
			<mat-icon>person</mat-icon>
			<span>Profile</span>
		</a>
		<mat-divider></mat-divider>
		<button mat-menu-item (click)="logout()">
			<mat-icon>logout</mat-icon>
			<span>Logout</span>
		</button>
	</mat-menu>
</mat-toolbar>
